module.exports = __webpack_public_path__ + "img/engage-fig-1.91bed92d.png";